import { createRecipe } from './runtime';

const emphasisConfig = {"name":"emphasis","defaultVariants":{"tone":"warm"},"variantMap":{"tone":["cool","warm"]}}

export const emphasis = /* @__PURE__ */ createRecipe(emphasisConfig)